import React from "react";
import { FlameIcon } from "lucide-react";
type ScarcityBarProps = {
  spotsLeft?: number;
  totalSpots?: number;
};
export function ScarcityBar({
  spotsLeft = 7,
  totalSpots = 100
}: ScarcityBarProps) {
  const filled = Math.round((totalSpots - spotsLeft) / totalSpots * 100);
  return <div className="mx-auto w-full max-w-md" data-id="element-51" data-mp="2q3hf6vop7men">
      <div className="mb-2 flex items-center justify-between gap-3 text-sm" data-id="element-52" data-mp="2q26ckz6zokp4">
        <span className="flex items-center gap-1.5 font-bold text-danger" data-id="element-53" data-mp="2b5p5ik5u1s8d">
          <FlameIcon className="h-4 w-4" aria-hidden="true" data-id="element-54" data-mp="2g6ctewyrlsyd" />
          Only {spotsLeft} spots left at $27
        </span>
        <span className="font-bold tabular-nums text-ink" data-id="element-55" data-mp="2273k8h8z7z3w">{filled}% claimed</span>
      </div>
      <div className="h-5 w-full overflow-hidden rounded-full bg-danger-soft ring-1 ring-danger/20" role="progressbar" aria-valuenow={filled} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-56" data-mp="2766i9hqjh52d">
        <div className="scarcity-stripes h-full rounded-full bg-danger" style={{
        width: `${filled}%`
      }} data-id="element-57" data-mp="33mmrqlb31trd" />
      </div>
      <p className="mt-2 text-center text-xs font-medium text-muted" data-id="element-58" data-mp="2zm2wxodzf28e">
        When the promotional spots run out, the price returns to the regular rate.
      </p>
    </div>;
}